import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/dc_img/schedule.svg")